import { useState } from 'react';
import type { ModalMode } from '../types';

export function useDirectoryEditModal<TItem extends { id: string }>(
    items: TItem[],
) {
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [itemToEdit, setItemToEdit] = useState<TItem | undefined>(undefined);
    const [modalMode, setModalMode] = useState<ModalMode>('edit');

    const openEditModal = (itemId: string, mode: ModalMode) => {
        const item = items.find((i) => i.id === itemId);
        if (!item) return;
        setItemToEdit(item);
        setModalMode(mode);
        setIsEditModalOpen(true);
    };

    const closeEditModal = () => {
        setIsEditModalOpen(false);
        setItemToEdit(undefined);
    };

    return {
        isEditModalOpen,
        modalMode,
        itemToEdit,
        openEditModal,
        closeEditModal,
        setIsEditModalOpen,
        setItemToEdit,
    };
}
